/**
 * 会话回复服务
 * 从 AZ_AI_MVR_H5/src/services/conReply.ts 迁移
 */
import request from "../../utils/request";

/** 创建会话回复 */
export function createConReply(data: { questionId?: string; content: string }) {
  return request
    .post("/project/conreply/create", {
      Entity: {
        QuestionId: data.questionId ?? "",
        Content: data.content,
      },
    })
    .then((r) => r.data);
}
